import { Toolbar, IconButton, Box, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HelpIcon from "@mui/icons-material/Help";
import { AppBar } from "./nav-styles";
import logo from "../../styles/logo.svg";
import dtlLogo from "../../styles/dtl-logo-hvid.png";
import padborgLogo from "../../styles/padborg-logo-hvid.png";
import FeatureToggle from "../FeatureToggle";
import UserAccountMenu from "./UserAccountMenu";
import Notifications from "./Notifications";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SettingsMenu from "./SettingsMenu";
import "./topbar.scss";
import { useFeature } from "../../hooks";
import PhoneIcon from "@mui/icons-material/Phone";
import { getLanguage } from "../../i18n/i18n";
import { useSelector } from "react-redux";
import { selectIsSupportUser } from "../../ducks/auth/selectors";

export default function TopBar(props: {
  open: boolean;
  handleDrawerOpen: () => void;
}) {
  const { t } = useTranslation("navigation");
  const navigate = useNavigate();
  const liteVersion = useFeature("lite-version");
  const liteVersionDtl = useFeature("lite-version-dtl-logo");
  const liteVersionPadborg = useFeature("lite-version-padborg-logo");
  const isSupportUser = useSelector(selectIsSupportUser);

  const onHelpClick = () => navigate("/help-and-support");
  const onLogoClick = () => navigate("/");
  const onNewsClick = () => navigate("/news");
  const language = getLanguage();

  return (
    <>
      <AppBar position="fixed" open={props.open}>
        <Toolbar variant="dense">
          <Box
            sx={{
              flexGrow: 1,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            {!liteVersion && (
              <IconButton
                color="inherit"
                onClick={props.handleDrawerOpen}
                className="top-menu-icon-button"
                edge="start"
                sx={{
                  marginRight: "36px",
                  ...(props.open && { display: "none" }),
                }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <img
              src={logo}
              height={17}
              alt="dora logo"
              onClick={onLogoClick}
              style={{ cursor: "pointer" }}
            />
            {liteVersion &&
              (liteVersionDtl || liteVersionPadborg ? (
                <img
                  src={
                    (liteVersionDtl && dtlLogo) ||
                    (liteVersionPadborg && padborgLogo) ||
                    ""
                  }
                  height={36}
                  alt="partner logo"
                  onClick={onLogoClick}
                  style={{ cursor: "pointer", marginLeft: 20 }}
                />
              ) : (
                <></>
              ))}
          </Box>

          {/* Inside the toolbar rather than a row below it: pages assume a
              48px header (e.g. calc(100vh - 48px)). */}
          {isSupportUser && (
            <Box
              sx={{
                // Centred on the toolbar itself: the boxes on either side
                // have different widths, so flex alone would push it off.
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                bgcolor: "error.main",
                color: "common.white",
                fontWeight: 600,
                px: 2,
                py: 0.5,
                borderRadius: 1,
                whiteSpace: "nowrap",
              }}
            >
              {t("topbar.supportUserBanner")}
            </Box>
          )}

          <Box
            sx={{
              flexGrow: 1,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-end",
              // justifyContent: "space-between",
              maxWidth: 620, // 420
            }}
          >
            {liteVersion && (
              <div className="mr-4 flex center">
                <PhoneIcon sx={{ mr: 1 }} /> +45 27 30 00 00
              </div>
            )}
            {language === "da" && (
              <Button
                variant="text"
                color="inherit"
                size="large"
                onClick={onNewsClick}
              >
                {t("topbar.news")}
              </Button>
            )}
            <Button
              variant="text"
              color="inherit"
              size="large"
              endIcon={<HelpIcon />}
              onClick={onHelpClick}
            >
              {t("topbar.helpAndSupport")}
            </Button>
            {/* <MuiTooltip title="OBS." placement="bottom">
                            <IconButton
                                color="inherit"
                                size="large"
                            >
                                <WarningIcon />
                            </IconButton>
                        </MuiTooltip> */}
            <FeatureToggle feature="userMenu">
              <Notifications />
            </FeatureToggle>
            <SettingsMenu />
            <UserAccountMenu />
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
}
